(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amm-help-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-amm-help-center]').forEach((section) => {
        if (section.dataset.ammHelpReady === 'true') return;
        section.dataset.ammHelpReady = 'true';

        const input = section.querySelector('[data-amm-help-search]');
        const clear = section.querySelector('[data-amm-help-clear]');
        const status = section.querySelector('[data-amm-help-status]');
        const empty = section.querySelector('[data-amm-help-empty]');
        const items = Array.from(section.querySelectorAll('[data-amm-help-item]'));

        if (!input || !clear || !status || !empty || !items.length) return;

        const filterItems = () => {
          const query = input.value.trim().toLowerCase();
          let visible = 0;

          items.forEach((item) => {
            const searchText = (item.dataset.searchText || item.textContent).toLowerCase();
            const match = !query || searchText.includes(query);
            item.hidden = !match;
            if (match) visible += 1;
            if (!match && item.tagName === 'DETAILS') item.open = false;
          });

          clear.hidden = !query;
          empty.hidden = !query || visible > 0;
          status.textContent = query ? `${visible} helpful ${visible === 1 ? 'result' : 'results'} found` : '';
        };

        input.addEventListener('input', filterItems);
        clear.addEventListener('click', () => {
          input.value = '';
          filterItems();
          input.focus();
        });

        section.querySelectorAll('a[href^="#"]').forEach((link) => {
          link.addEventListener('click', () => {
            const target = section.querySelector(link.getAttribute('href'));
            if (target && target.tagName === 'DETAILS') target.open = true;
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amm-track-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadTracker = () => {
      if (window.YQV5) return Promise.resolve(window.YQV5);
      if (window.amm17TrackScriptPromise) return window.amm17TrackScriptPromise;

      window.amm17TrackScriptPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-amm-17track]');
        const script = existing || document.createElement('script');
        const timer = window.setTimeout(() => reject(new Error('Tracking service timeout')), 12000);

        const complete = () => {
          window.clearTimeout(timer);
          if (window.YQV5) resolve(window.YQV5);
          else reject(new Error('Tracking service unavailable'));
        };

        script.addEventListener('load', complete, { once: true });
        script.addEventListener('error', () => {
          window.clearTimeout(timer);
          reject(new Error('Tracking service unavailable'));
        }, { once: true });

        if (!existing) {
          script.src = 'https://www.17track.net/externalcall.js';
          script.async = true;
          script.setAttribute('data-amm-17track', '');
          document.head.appendChild(script);
        }
      });

      return window.amm17TrackScriptPromise;
    };

    const initialize = (root = document) => {
      root.querySelectorAll('[data-amm-track-order]').forEach((section) => {
        if (section.dataset.ammTrackReady === 'true') return;
        section.dataset.ammTrackReady = 'true';

        const form = section.querySelector('[data-amm-track-form]');
        const input = section.querySelector('[data-amm-track-input]');
        const button = section.querySelector('[data-amm-track-button]');
        const status = section.querySelector('[data-amm-track-status]');
        const results = section.querySelector('[data-amm-track-results]');
        const container = section.querySelector('[data-amm-track-container]');

        if (!form || !input || !button || !status || !results || !container) return;

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const trackingNumber = input.value.trim();

          if (!trackingNumber) {
            input.focus();
            input.reportValidity();
            return;
          }

          button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          status.textContent = section.dataset.loadingText;
          results.hidden = true;
          container.replaceChildren();

          try {
            const tracker = await loadTracker();
            results.hidden = false;
            tracker.trackSingle({
              YQ_ContainerId: container.id,
              YQ_Height: 620,
              YQ_Fc: '0',
              YQ_Lang: 'en',
              YQ_Num: trackingNumber
            });
            status.textContent = '';
            window.setTimeout(() => results.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 120);
          } catch (error) {
            status.textContent = section.dataset.errorText;
            const fallback = document.createElement('a');
            fallback.href = 'https://www.17track.net/en';
            fallback.target = '_blank';
            fallback.rel = 'noopener';
            fallback.textContent = 'Open 17TRACK';
            status.append(' ');
            status.append(fallback);
          } finally {
            button.disabled = false;
            form.removeAttribute('aria-busy');
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const initialized = new WeakSet();

    const setupMenus = (root = document) => {
      root.querySelectorAll('.amm-footer__menu').forEach((menu) => {
        if (initialized.has(menu)) return;

        initialized.add(menu);
        menu.addEventListener('toggle', () => {
          if (!mobileQuery.matches || !menu.open) return;

          const footer = menu.closest('.amm-footer');
          footer?.querySelectorAll('.amm-footer__menu').forEach((otherMenu) => {
            if (otherMenu !== menu) otherMenu.open = false;
          });
        });
      });
    };

    const syncMenus = (root = document) => {
      root.querySelectorAll('.amm-footer__menu').forEach((menu) => {
        menu.open = !mobileQuery.matches;
      });
    };

    const initialize = () => {
      setupMenus();
      syncMenus();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    mobileQuery.addEventListener('change', () => syncMenus());
    document.addEventListener('shopify:section:load', (event) => {
      setupMenus(event.target);
      syncMenus(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-brand-residence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const setup = (root) => {
      root.querySelectorAll('.nr-brand-residence').forEach((section) => {
        if (initialized.has(section)) return;

        const rail = section.querySelector('.nr-brand-residence__products');
        const dots = [...section.querySelectorAll('.nr-brand-residence__dots span')];
        if (!rail || dots.length === 0) return;

        initialized.add(section);
        let frame;

        const update = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const maximum = rail.scrollWidth - rail.clientWidth;
            const progress = maximum > 0 ? Math.abs(rail.scrollLeft) / maximum : 0;
            const index = Math.min(dots.length - 1, Math.round(progress * (dots.length - 1)));

            dots.forEach((dot, dotIndex) => {
              dot.classList.toggle('is-active', dotIndex === index);
            });
          });
        };

        rail.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    };

    const initialize = () => setup(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-design-detail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-nr-anatomy]').forEach((section) => {
        if (section.dataset.nrAnatomyReady === 'true') return;
        section.dataset.nrAnatomyReady = 'true';

        const targets = Array.from(section.querySelectorAll('[data-nr-feature]'));
        const details = Array.from(section.querySelectorAll('.nr-anatomy__accordion details'));

        const setActive = (index) => {
          targets.forEach((element) => {
            element.classList.toggle('is-active', element.dataset.nrFeature === index);
          });
        };

        section.querySelectorAll('.nr-anatomy__callout').forEach((callout) => {
          const activate = () => setActive(callout.dataset.nrFeature);
          callout.addEventListener('mouseenter', activate);
          callout.addEventListener('focusin', activate);
        });

        section.querySelectorAll('.nr-anatomy__marker').forEach((marker) => {
          marker.addEventListener('click', () => {
            const matchingDetail = details.find(
              (detail) => detail.dataset.nrFeature === marker.dataset.nrFeature
            );

            details.forEach((detail) => {
              detail.open = detail === matchingDetail;
            });

            setActive(marker.dataset.nrFeature);
          });
        });

        details.forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (!detail.open) return;

            details.forEach((other) => {
              if (other !== detail) other.open = false;
            });

            setActive(detail.dataset.nrFeature);
          });
        });

        setActive('0');
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-journey-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const setup = (root) => {
      root.querySelectorAll('.nr-journey-edit').forEach((section) => {
        if (initialized.has(section)) return;

        const rail = section.querySelector('.nr-journey-edit__products');
        const dots = [...section.querySelectorAll('.nr-journey-edit__dots span')];
        if (!rail || dots.length === 0) return;

        initialized.add(section);
        let frame;

        const update = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const maximum = rail.scrollWidth - rail.clientWidth;
            const progress = maximum > 0 ? Math.abs(rail.scrollLeft) / maximum : 0;
            const index = Math.min(dots.length - 1, Math.round(progress * (dots.length - 1)));

            dots.forEach((dot, dotIndex) => {
              dot.classList.toggle('is-active', dotIndex === index);
            });
          });
        };

        rail.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    };

    const initialize = () => setup(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-latest-drop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const setup = (root) => {
      root.querySelectorAll('.nr-latest-drop').forEach((section) => {
        if (initialized.has(section)) return;

        const rail = section.querySelector('.nr-latest-drop__rail');
        const dots = [...section.querySelectorAll('.nr-mobile-dots span')];
        if (!rail || dots.length === 0) return;

        initialized.add(section);
        let frame;

        const update = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const maximum = rail.scrollWidth - rail.clientWidth;
            const progress = maximum > 0 ? Math.abs(rail.scrollLeft) / maximum : 0;
            const index = Math.min(dots.length - 1, Math.round(progress * (dots.length - 1)));

            dots.forEach((dot, dotIndex) => {
              dot.classList.toggle('is-active', dotIndex === index);
            });
          });
        };

        rail.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    };

    const initialize = () => setup(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
